/* eslint-disable indent */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { useDispatch, useSelector } from "react-redux";
import AxisFiltersRecap from "./AxisFiltersRecap";
import BundleRecap from "./BundleRecap";
import BundleDetails from "./BundleDetails";
import {
  collapseAxisDetails,
  selectItemToHighlight,
  setItemToHighlight,
  duplicateAxis,
  selectRetrofitConfiguration,
  updateAxisName
} from "../../../store/slices/retrofit";
import EditableAxisName from "../Axes/EditableAxisName";
import useCheckMobileScreen from "../../../utils/common/useCheckMobileScreen";
import MsxIcons from "../../common/Icons/MsxIcons/MsxIcons";
import t from "../../../utils/common/translation/translator";
import { updateConfiguration } from "../../../store/slices/common";

const AxisRecap = ({ axis, uncollapsed, print }) => {
  const dispatch = useDispatch();
  const collapseDetails = (e) => {
    e.stopPropagation();
    dispatch(collapseAxisDetails(axis.id));
  };
  const configuration = useSelector(selectRetrofitConfiguration);

  const itemToHighlight = useSelector(selectItemToHighlight);

  const [isCardCollapsed, setCardCollapsed] = useState(true);

  useEffect(() => {
    dispatch(setItemToHighlight(`Axis-${configuration.configData.axes[configuration.configData.axes.length - 1].id}`));
  }, duplicateAxis);

  useEffect(() => {
    if (itemToHighlight === `Axis-${axis.id}`) {
      setTimeout(() => {
        dispatch(setItemToHighlight(null));
      }, 1500);
    }
  }, [itemToHighlight]);

  useEffect(() => {
    if (itemToHighlight === `Axis-${axis.id}`) {
      setCardCollapsed(false);
    }
    if (
      itemToHighlight !== `Axis-${axis.id}` &&
      axis.id !== configuration.configData.axes[configuration.configData.axes.length - 1].id
    ) {
      setCardCollapsed(true);
    }
  }, [itemToHighlight]);

  const isMobile = useCheckMobileScreen();

  const handleUpdateAxisName = (newName) => {
    if (!newName) {
      return;
    }
    dispatch(updateAxisName({ axisId: axis.id, name: newName }));
    dispatch(updateConfiguration());
  };

  if (isMobile && !print) {
    return (
      <div
        className={`group rounded-sm border-[1px] border-solid border-gray-200 border-l-4 transition-all duration-100
     ${axis.bundle?.motorReference ? "border-l-primary" : "border-l-gray-300 hover:border-l-gray-400"} 
     ${
       itemToHighlight === `Axis-${axis.id}`
         ? "outline outline-2 outline-primary hover:outline hover:outline-2 hover:outline-primary"
         : ""
     }
     bg-white my-1 cursor-pointer transition-all duration-100 hover:shadow select-none print:break-inside-avoid`}
      >
        <div
          onClick={() => setCardCollapsed(!isCardCollapsed)}
          className="flex flex-col space-y-2 border-solid border-gray-200 px-4 py-3"
        >
          <div className="flex justify-between">
            <div className="max-w-[45%]">
              <EditableAxisName
                axisName={axis.name}
                onConfirm={(newName) => {
                  handleUpdateAxisName(newName);
                }}
                configId={configuration?.configId}
              />
            </div>
            <div className="flex items-center">
              {isCardCollapsed &&
                (axis.bundle?.motorReference ? (
                  <div
                    className="flex items-center space-x-1 text-secondary
"
                  >
                    <MsxIcons name="check_filled" size="nano" />
                    <div>{t("msizer.ui.select.bundle_selected")}</div>
                  </div>
                ) : (
                  <div className="flex items-center space-x-1 text-gray-500">
                    <MsxIcons name="alert_rounded" size="nano" />
                    <div>{t("msizer.ui.select.no_bundle_selected")}</div>
                  </div>
                ))}
              <div className="collapsible-header-icon">
                <MsxIcons
                  className={`transition-all duration-100 mx-2 ${!isCardCollapsed ? "rotate-180" : ""}`}
                  name="arrow-down"
                  size="nano"
                  onClick={() => setCardCollapsed(!isCardCollapsed)}
                />
              </div>
            </div>
          </div>
          {!isCardCollapsed && (
            <>
              <AxisFiltersRecap axis={axis} />
              {axis.bundle?.motorReference && (
                <button
                  className="flex print:hidden justify-between items-center border-[1px] border-gray-400 rounded-sm py-2 px-3.5 text-left font-semibold text-secondary
"
                  type="button"
                  onClick={axis.bundle?.motorReference && collapseDetails}
                >
                  {t("msizer.ui.specify.view_bundle")}
                  <MsxIcons
                    className={`text-gray-400 transition-all duration-100 mx-2 ${!axis.collapsed ? "rotate-180" : ""}`}
                    name="arrow-down"
                    size="nano"
                  />
                </button>
              )}
              {axis.bundle?.motorReference && (!axis.collapsed || uncollapsed) && <BundleDetails axis={axis} />}
              <BundleRecap axis={axis} editingMode={!!axis.bundle?.motorReference} />
            </>
          )}
        </div>
      </div>
    );
  }

  return (
    <div
      className={`group border-[1px] border-solid border-gray-200 border-l-4 transition-all duration-100
     ${axis.bundle?.motorReference ? "border-l-primary" : "border-l-gray-300 hover:border-l-gray-400"} 
     ${
       itemToHighlight === `Axis-${axis.id}`
         ? "outline outline-2 outline-primary hover:outline hover:outline-2 hover:outline-primary"
         : ""
     }
     bg-gray-5 cursor-pointer transition-all duration-100 select-none print:break-inside-avoid`}
    >
      <div className="hidden print:block print:visible print:py-2 print:px-4">
        <EditableAxisName
          axisName={axis.name}
          onConfirm={(newName) => {
            handleUpdateAxisName(newName);
          }}
          configId={configuration?.configId}
        />
      </div>
      <div
        className="grid grid-cols-9 lg:grid-cols-8 border-solid border-gray-200 pl-2"
        onClick={axis.bundle?.motorReference && collapseDetails}
      >
        <div className="print:hidden flex items-center">
          <EditableAxisName
            axisName={axis.name}
            onConfirm={(newName) => {
              handleUpdateAxisName(newName);
            }}
            configId={configuration?.configId}
          />
        </div>
        <AxisFiltersRecap axis={axis} print />
        <BundleRecap axis={axis} editingMode={!!axis.bundle?.motorReference} />
      </div>
      {axis.bundle?.motorReference && (!axis.collapsed || uncollapsed) && <BundleDetails axis={axis} />}
    </div>
  );
};

AxisRecap.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  axis: PropTypes.any.isRequired,
  uncollapsed: PropTypes.bool,
  print: PropTypes.bool
};

AxisRecap.defaultProps = {
  uncollapsed: undefined,
  print: undefined
};

export default AxisRecap;
